import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWatermarkRemoverConfig } from '@/data/landingConfig/landingWatermarkRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WatermarkRemover } from './schemaObject';

interface Props {}
const WatermarkRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WatermarkRemover} />
			<VideoLandingTemplate
				data={landingWatermarkRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelWatermarkRemoverV2()}
			/>
		</>
	);
};

export default WatermarkRemover;
